import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import WOW from "wowjs";
import noproduct from '../assets/img/icons/no-product.jpg';
import { Helmet } from "react-helmet-async";

const Services = () => {

    const { id } = useParams(); // Get ID from the URL
    const [services, setServices] = useState([]);
    const [categoryName, setCategoryName] = useState("home");


    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const itemsPerPage = 9; // Number of services per page

    useEffect(() => {
        new WOW.WOW().init(); // Initialize WOW.js animation
    }, []);

    useEffect(() => {
        fetchServices();
        setCurrentPage(1); // Reset to page 1 when ID changes
    }, [id]);

    const fetchServices = async () => {
        setLoading(true);
        try {
            const response = await fetch(`https://jiimpex.com/new_project/ji-impex/add-product.php?id=${id}`);
            const data = await response.json();
            console.log("API Response:", data);

            if (data && data.products) {
                setCategoryName(data.category_name);
                setServices(data.products);
            } else {
                setServices([]); // Set empty if no products found
            }
        } catch (error) {
            console.error("Error fetching services:", error);
        } finally {
            setLoading(false);
        }

    };

    // Get the services for the current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentServices = services.slice(indexOfFirstItem, indexOfLastItem);

    // Handle pagination click
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <>
            {/* Page Title */}
            <Helmet>
                <title>{categoryName} || JI IMPEX</title>
            </Helmet>
            {/* Page Header Section */}
            <div className="container-fluid page-header py-5 mb-5 wow fadeIn product-page" data-wow-delay="0.1s">
                <div className="container text-center py-5">
                    <h1 className="display-4 text-white animated slideInDown mb-4">Our Products</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb justify-content-center mb-0">
                            <li className="breadcrumb-item"><a className="text-white" href="/">Home</a></li>
                            <li className="breadcrumb-item text-primary active" aria-current="page">{categoryName}</li>
                        </ol>
                    </nav>
                </div>
            </div>

            {/* Services Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5 align-items-end mb-5">
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="border-start border-5 border-primary ps-4">
                                {/* <h6 className="text-body text-uppercase mb-2">Our Products</h6> */}
                                {/* <h1 className="display-6 mb-0">Construction And Renovation Solutions</h1> */}
                            </div>
                        </div>
                    </div>
                    {(loading ? (
                        [...Array(6)].map((_, index) => (
                            <div className="col-lg-4 col-md-6" key={index}>
                                <div className="service-item bg-light overflow-hidden h-100 placeholder-glow">
                                    <div className="img-fluid bg-secondary placeholder w-100" style={{ height: '200px' }}></div>
                                    <div className="service-text position-relative text-center h-100 p-4">
                                        <h5 className="mb-3 placeholder w-75 mx-auto"></h5>
                                        <p className="placeholder w-100"></p>
                                        <p className="placeholder w-50 mx-auto"></p>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="row g-4 justify-content-center">
                            {currentServices.length > 0 ? (
                                currentServices.map((service, index) => (
                                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`} key={service.id}>
                                        <div className="service-item bg-light overflow-hidden h-100">
                                            <img className="img-fluid" src={service.image_url} alt={service.name} />
                                            <div className="service-text position-relative text-center h-100 p-4">
                                                <h5 className="mb-3">{service.name}</h5>
                                                <p dangerouslySetInnerHTML={{ __html: service.description }}></p>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center py-5">
                                    <img src={noproduct} alt="No Products" className="img-fluid" style={{ maxWidth: "200px" }} />
                                    <h4 className="mt-3 text-muted">No Products Available</h4>
                                    <p className="text-muted">We're sorry, but there are no products available at the moment.</p>
                                    {/* <button className="btn btn-primary" onClick={() => window.location.reload()}>Refresh</button> */}
                                </div>
                            )}
                        </div>

                    ))}


                    {/* Pagination */}
                    {services.length > itemsPerPage && (
                        <div className="pagination mt-5 text-center">
                            <button
                                className={`px-3 py-2 mx-1 ${currentPage === 1 ? "bg-gray-300 cursor-not-allowed" : "bg-primary text-white"}`}
                                disabled={currentPage === 1}
                                onClick={() => paginate(currentPage - 1)}
                            >
                                Prev
                            </button>
                            {[...Array(Math.ceil(services.length / itemsPerPage))].map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => paginate(index + 1)}
                                    className={`px-3 py-2 mx-1 ${currentPage === index + 1 ? "bg-primary text-white" : "bg-gray-200"
                                        }`}
                                >
                                    {index + 1}
                                </button>
                            ))}
                            <button
                                className={`px-3 py-2 mx-1 ${currentPage === Math.ceil(services.length / itemsPerPage) ? "bg-gray-300 cursor-not-allowed" : "bg-primary text-white"
                                    }`}
                                disabled={currentPage === Math.ceil(services.length / itemsPerPage)}
                                onClick={() => paginate(currentPage + 1)}
                            >
                                Next
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {(loading == false && currentServices.length > 0) && (
                <div className="container-xxl py-5">
                    {categoryName === "Main / Auxiliary Engines & Spares" && (
                        <>
                            <h3 style={{ textAlign: "center", marginBottom: "15px" }}>Description</h3>
                            <div className="row" style={{ justifyContent: "center" }}>
                                {/* Column 1 */}
                                <div className="col-lg-2 col-md-6 col-sm-6">
                                    <ul className="list2">
                                        <li>MAN-B&amp;W</li>
                                        <li>SULZER</li>
                                        <li>WARTSILA</li>
                                        <li>MAK</li>
                                        <li>DEUTZ</li>
                                        <li>PIELSTICK</li>
                                        <li>MITSUBISHI</li>
                                        <li>MWM</li>
                                    </ul>
                                </div>

                                {/* Column 2 */}
                                <div className="col-lg-2 col-md-6 col-sm-6">
                                    <ul className="list2">
                                        <li>Daihatsu</li>
                                        <li>Yanmar</li>
                                        <li>Bergen</li>
                                        <li>Nigata</li>
                                        <li>Allen</li>
                                        <li>Stork</li>
                                        <li>Fiat</li>
                                    </ul>
                                </div>

                                {/* Column 3 */}
                                <div className="col-lg-2 col-md-6 col-sm-6">
                                    <ul className="list2">
                                        <li>HansHin</li>
                                        <li>Caterpillar</li>
                                        <li>SKL</li>
                                        <li>Ruston</li>
                                        <li>Paxman</li>
                                        <li>Crepelle</li>
                                        <li>Mirrlees</li>
                                    </ul>
                                </div>
                            </div>
                        </>
                    )}
                    {categoryName === "Fresh Water Generators" && (
                        <div className="row table-row">
                            {/* Alfa Laval Section */}
                            <div className="col-lg-6 col-md-7 col-sm-7 wow fadeInUp" data-wow-delay="0.1s">
                                <h3>Make: Alfa Laval</h3>
                                <p><b>Verfügbare Typen:</b></p>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <ul className="list2">
                                            <li>JWP 26C</li>
                                            <li>JWP 80</li>
                                            <li>JWP 26C 100</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Sasakura Section */}
                            <div className="col-lg-6 col-md-7 col-sm-7 wow fadeInUp" data-wow-delay="0.1s">
                                <h3>Make: Sasakura</h3>
                                <p><b>Verfügbare Typen:</b></p>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <ul className="list2">
                                            <li>K-Serie</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {categoryName === "Separators / Centrifuge" && (
                        <div className="row" style={{ justifyContent: "center" }}>
                            {/* ALFA LAVAL Section */}
                            <div className="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }} data-wow-delay="0.1s">
                                <h3 style={{ marginLeft: "250px" }}>ALFA LAVAL</h3>
                                <div className="row">
                                    {[
                                        ["MAB-103", "MAB-104", "MAB-204", "MAB-205", "MAB-206", "MAB-207", "MAB-209", "MAPX-204", "MAPX-205", "MAPX-207", "MAPX-309", "MAPX-310", "MAPX-313", "MOPX-205", "MOPX-207"],
                                        ["MOPX-209", "MOPX-213", "MOPX-310", "WHPX-405", "WHPX-407", "WHPX-409", "WHPX-410", "WHPX-505", "WHPX-507", "WHPX-508", "WHPX-510", "WHPX-513", "FOPX-605", "FOPX-607", "FOPX-609"],
                                        ["FOPX-610", "FOPX-613", "LOPX-705", "LOPX-707", "LOPX-709", "LOPX-710", "MMPX-303", "MMPX-304", "MMPX-403", "MMPX-404", "SU-300", "SU-400", "SU-826", "SU-831", "SU-841"]
                                    ].map((items, index) => (
                                        <div className="col-lg-4 col-md-6 col-sm-6" key={index}>
                                            <ul className="list2">
                                                {items.map((item, i) => <li key={i}>{item}</li>)}
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* WESTFALIA Section */}
                            <div className="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }} data-wow-delay="0.1s">
                                <h3 style={{ marginLeft: "250px" }}>WESTFALIA</h3>
                                <div className="row">
                                    {[
                                        ["OSA-07", "OSA-20", "OSA-35", "OSB-35"],
                                        ["OSD-06", "OSD-18", "OTA-02", "OTA-07"],
                                        ["OTA-14", "OTB-02", "OTC-02", "WSC-05"]
                                    ].map((items, index) => (
                                        <div className="col-lg-4 col-md-6 col-sm-6" key={index}>
                                            <ul className="list2">
                                                {items.map((item, i) => <li key={i}>{item}</li>)}
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* MITSUBISHI Section */}
                            <div className="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }} data-wow-delay="0.1s">
                                <h3 style={{ marginLeft: "250px" }}>MITSUBISHI</h3>
                                <div className="row">
                                    {[
                                        ["SJ-700", "SJ-2000", "SJ-3000", "SJ-4000", "SJ-6000"],
                                        ["SJ-8000", "SJ-10 T", "SJ-11 T", "SJ-15 T", "SJ-16 T"],
                                        ["SJ-20T", "SJ-25 T", "SJ-30 T/EH", "SJ-40 T", "SJ-60 T/EH"]
                                    ].map((items, index) => (
                                        <div className="col-lg-4 col-md-6 col-sm-6" key={index}>
                                            <ul className="list2">
                                                {items.map((item, i) => <li key={i}>{item}</li>)}
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    )}
                    {categoryName === "Decanter Centrifuge" && (
                        <div className="row" style={{ justifyContent: "center" }}>
                            {/* Alfa Laval, Westfalia, Mitsubishi Section */}
                            <div className="col-lg-3 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }} data-wow-delay="0.1s">
                                {[
                                    { title: "Alfa Laval", items: ["NX 309", "NX 418"] },
                                    { title: "WESTFALIA", items: ["CA 220", "CA 366"] },
                                    { title: "MITSUBISHI", items: ["KVZ 25 ML", "KVZ 35 ML"] }
                                ].map((section, index) => (
                                    <div key={index}>
                                        <h3>{section.title}</h3>
                                        <div className="row">
                                            <div className="col-lg-12 col-md-6 col-sm-6">
                                                <ul className="list2">
                                                    {section.items.map((item, i) => <li key={i}>{item}</li>)}
                                                </ul>
                                            </div>
                                        </div>
                                        <br />
                                    </div>
                                ))}
                            </div>

                            {/* Penwalt, Sharples Section */}
                            <div className="col-lg-3 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }} data-wow-delay="0.1s">
                                {[
                                    { title: "Penwalt", items: ["P 3400", "P 3000"] },
                                    { title: "Sharples", items: ["JPU 7963"] }
                                ].map((section, index) => (
                                    <div key={index}>
                                        <h3>{section.title}</h3>
                                        <div className="row">
                                            <div className="col-lg-12 col-md-6 col-sm-6">
                                                <ul className="list2">
                                                    {section.items.map((item, i) => <li key={i}>{item}</li>)}
                                                </ul>
                                            </div>
                                        </div>
                                        <br />
                                    </div>
                                ))}
                            </div>
                        </div>

                    )}
                    {categoryName === "Plate Heat Exchangers" && (
                        <div class="row" style={{ justifyContent: "center" }}>

                            {/* <!-- ALFA LAVAL Section --> */}
                            <div class="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3 style={{ marginLeft: "150px" }}>ALFA LAVAL</h3>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>A 10</li>
                                            <li>A 15 B</li>
                                            <li>A 20</li>
                                            <li>A 20 HBM</li>
                                            <li>A 30</li>
                                            <li>A 45 BFM</li>
                                            <li>A 20H</li>
                                            <li>A 15H</li>
                                            <li>A 10B</li>
                                            <li>A 20B</li>
                                            <li>AK 20</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>AM 10</li>
                                            <li>AM 20</li>
                                            <li>AM 20B</li>
                                            <li>AM 20H</li>
                                            <li>AX 30</li>
                                            <li>AX 30B</li>
                                            <li>M 10B</li>
                                            <li>M 10M</li>
                                            <li>M 15M</li>
                                            <li>M 30M</li>
                                            <li>M 20M</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>M 15B</li>
                                            <li>M6</li>
                                            <li>P 22</li>
                                            <li>P 252</li>
                                            <li>P 26</li>
                                            <li>P 31 HX</li>
                                            <li>P 32</li>
                                            <li>P 36</li>
                                            <li>P 45</li>
                                            <li>PO 1</li>
                                            <li>PO 2</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- GEA Section --> */}
                            <div class="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3 style={{ marginLeft: "250px" }}>GEA</h3>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>VT 40 CDM-10</li>
                                            <li>VT 40 CDS-10</li>
                                            <li>VT 405 CDS-6</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>VT 40</li>
                                            <li>VT 80</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>VT 805</li>
                                            <li>NT 150</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- APV Section --> */}
                            <div class="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3 style={{ marginLeft: "250px" }}>APV</h3>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>A-55</li>
                                            <li>H-17</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>K-34</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>K-55</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Tranter Section --> */}
                            <div class="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3 style={{ marginLeft: "250px" }}>Tranter</h3>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>GX 51</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>GX 60</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>GX 100</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Sondex Section --> */}
                            <div class="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3 style={{ marginLeft: "250px" }}>Sondex</h3>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>S 35</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>S 65</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>SDF SERIES</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Swep Section --> */}
                            <div class="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3 style={{ marginLeft: "250px" }}>Swep</h3>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>GX Series</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>GXD Series</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {categoryName === "Air Compressor" && (
                        <div class="row" style={{ justifyContent: "center" }}>

                            {/* <!-- Description Section --> */}
                            <div class="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3 style={{ marginLeft: "150px" }}>Description</h3>

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Hamworthy</li>
                                            <li>Hatlapa</li>
                                            <li>Sperry</li>
                                            <li>Yanmar</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Tanabe</li>
                                            <li>Sulzer</li>
                                            <li>J.P. Sauer &amp; Sohn</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    )}
                    {categoryName === "Hydraulic Motor & Pumps" && (
                        <div class="row" style={{ justifyContent: "center" }}>

                            {/* <!-- Description Section --> */}
                            <div class="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3 style={{ marginLeft: "150px" }}>Description</h3>

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>IHI</li>
                                            <li>Hagglund</li>
                                            <li>Fukushima</li>
                                            <li>Hydromatik Rexroth</li>
                                            <li>Kawasaki Staffa</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Mitsubishi</li>
                                            <li>Norwinch</li>
                                            <li>Nachi</li>
                                            <li>Dension</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    )}
                    {categoryName === "Turbo Chargers" && (
                        <div class="row" style={{ justifyContent: "center" }}>

                            {/* <!-- Description Section --> */}
                            <div class="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3 style={{ marginLeft: "150px" }}>Zur Verfugung stellt</h3>

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>BBC</li>
                                            <li>IHI</li>
                                            <li>ABB</li>
                                            <li>Napier</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>SKL</li>
                                            <li>MAN</li>
                                            <li>Mitsubishi</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    )}
                    {categoryName === "Bow Thrusters" && (
                        <div class="row" style={{ justifyContent: "center" }}>

                            {/* <!-- Description Section --> */}
                            <div class="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3 style={{ marginLeft: "150px" }}>Description</h3>

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Lips</li>
                                            <li>Kamewa</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Hatlapa</li>
                                            <li>Brunvoll</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    )}
                    {categoryName === "Chilling Compressor" && (
                        <div class="row" style={{ justifyContent: "center" }}>
                            {/* <!-- Product Description Section --> */}
                            <div class="col-lg-3 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3>Sabroe</h3>
                                <ul class="list2">
                                    <li>SMC-100</li>
                                    <li>TSMC</li>
                                    <li>SMC-104S/L</li>
                                    <li>106S/L</li>
                                    <li>108S/L</li>
                                    <li>112S/L</li>
                                    <li>SMC 65 ALL MODELS</li>
                                    <li>CM0-14/16/18 &amp; 24/26/28</li>
                                </ul>

                                <h3>DYKIN</h3>
                                <ul class="list2">
                                    <li>HC 55 &amp; C 75</li>
                                    <li>Semisealed Series</li>
                                </ul>

                                <h3>Carrier</h3>
                                <ul class="list2">
                                    <li>6D Series</li>
                                    <li>6E Series</li>
                                    <li>5F All Models</li>
                                    <li>5H All Models</li>
                                </ul>

                                <h3>Bitzer</h3>
                                <ul class="list2">
                                    <li>4-G</li>
                                    <li>6-G</li>
                                </ul>

                                <h3>Bock</h3>
                                <ul class="list2">
                                    <li>3, 4 &amp; 5</li>
                                </ul>

                                <h3>Copeland</h3>
                                <ul class="list2">
                                    <li>2CK-56</li>
                                    <li>2CK-38</li>
                                    <li>4CC-75</li>
                                    <li>6CC-75</li>
                                </ul>
                            </div>

                            {/* <!-- Additional Product Section --> */}
                            <div class="col-lg-4 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3>GRASSO</h3>
                                <ul class="list2">
                                    <li>Refrigeration AC-70 &amp; AC-80</li>
                                    <li>RC 11 &amp; RC 12</li>
                                    <li>RC 6</li>
                                    <li>RC 9</li>
                                </ul>

                                <h3>Trane</h3>
                                <ul class="list2">
                                    <li>E Series: 3E 5H-40, 50, 60, 80</li>
                                    <li>F Series: 3F 5B-40, 50, 60</li>
                                    <li>5H All Models</li>
                                </ul>

                                <h3>Mycom</h3>
                                <ul class="list2">
                                    <li>A &amp; B</li>
                                </ul>

                                <h3>Stal</h3>
                                <ul class="list2">
                                    <li>P22</li>
                                    <li>P24</li>
                                    <li>P4</li>
                                    <li>P6</li>
                                    <li>P8 and all Models U 2/4/6/8</li>
                                </ul>

                                <h3>YORK</h3>
                                <ul class="list2">
                                    <li>JS series</li>
                                </ul>
                            </div>
                        </div>
                    )}
                    {categoryName === "Oil Mist Detector" && (
                        <div class="row" style={{ justifyContent: "center" }}>

                            {/* <!-- Description Section --> */}
                            <div class="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3 style={{ marginLeft: "150px" }}>Description</h3>

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Scaler</li>
                                            <li>Graviner - MK5</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Graviner - MK6</li>
                                            <li>Daihastu</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {categoryName === "Governor" && (
                        <div class="row" style={{ justifyContent: "center" }}>

                            {/* <!-- Product Description Section --> */}
                            <div class="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3 style={{ marginLeft: "150px" }}>Macht</h3>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>WOODWARD</li>
                                            <li>ZEXEL</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>DIESELKIKI</li>
                                        </ul>
                                    </div>
                                </div>

                                <h3 style={{ marginLeft: "150px" }}>Good</h3>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Woodward Governors - UG8D, UG8L, UG40, PSG, PGA, SG, 3161</li>
                                            <li>Regulateurs Europa Governors (RE Governors) - 1101, 1102, 1103, 1104, 1104A, 1131, 400</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Zexel and Diesel Kiki Governors - RHD6, RHD6MC, RHD6MCL, RHD6PC</li>
                                            <li>Blackstone Hydraulic</li>
                                        </ul>
                                    </div>
                                </div>

                                <h3 style={{ marginLeft: "150px" }}>Governors</h3>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Woodward Governors</li>
                                            <li>Woodward UG8D Governor</li>
                                            <li>Woodward UG40D Governor</li>
                                            <li>Woodward SG Governor</li>
                                            <li>Woodward TG-13 Governor</li>
                                            <li>Woodward PGA200 Governor</li>
                                            <li>Woodward PG500 Governor</li>
                                            <li>Woodward PG-PL Governor</li>
                                            <li>Woodward EGB P. / EGB 10 P. / EGB 13P. / EGB 500P</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Woodward UG8L Governor</li>
                                            <li>Woodward UG10 Governor</li>
                                            <li>Woodward UGA Governor</li>
                                            <li>Woodward PSG Governor</li>
                                            <li>Woodward PGA Governor</li>
                                            <li>Woodward PGA300 Governor</li>
                                            <li>Woodward PGD Governor</li>
                                            <li>Woodward 3161 Governor</li>
                                        </ul>
                                    </div>
                                </div>

                                <h3 style={{ marginLeft: "150px" }}>Governor Controllers</h3>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Regulateurs Europa Governors (RE Governors)</li>
                                            <li>Regulateurs Europa 1101 Governor</li>
                                            <li>Regulateurs Europa 1104 Governor</li>
                                            <li>Regulateurs Europa 1131 Governor</li>
                                            <li>Diesel Kiki &amp; Zexel Governors</li>
                                            <li>Diesel Kiki RHD6MC Governor</li>
                                            <li>Diesel Kiki RHD6PC Governor</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Regulateurs Europa 1102 Governor</li>
                                            <li>Regulateurs Europa 1103 Governor</li>
                                            <li>Regulateurs Europa 1104A Governor</li>
                                            <li>Regulateurs Europa 400 Governor</li>
                                            <li>Diesel Kiki RHD6 Governor</li>
                                            <li>Diesel Kiki RHD6MCL Governor</li>
                                            <li>Ug 8</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    )}
                    {categoryName === "Processing Equipments" && (
                        <div class="row" style={{ justifyContent: "center" }}>

                            {/* <!-- Description Section --> */}
                            <div class="col-lg-7 col-md-7 col-sm-7 wow fadeInUp" style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
                                <h3>Description</h3>

                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <ul class="list2">
                                            <li>Baader</li>
                                        </ul>
                                    </div>
                                    {/* <div class="col-lg-6 col-md-6 col-sm-6">
                                    <ul class="list2">
                                        <li>Graviner - MK6</li>
                                        <li>Daihastu</li>
                                    </ul>
                                </div> */}
                                </div>
                            </div>
                        </div>
                    )}
                </div>)}


        </>
    );
};

export default Services;
